/**
 * UI metadata and pane ordering for indicators (TradingView-style groupings).
 * Calculations live in indicatorCalculations.js; Chart.js wires series from this order.
 */

/** Bottom panes: first listed gets pane index 1 when active. */
export const OSCILLATOR_ORDER_KEYS = [
  "rsi",
  "cci",
  "williams",
  "roc",
  "momentum",
  "stochastic",
  "stochRsi",
  "macd",
  "atr",
  "adx",
  "ao",
  "tsi",
  "obv",
  "cmf",
  "mfi",
  "chaikinVol",
  "volOsc",
  "adLine",
  "stdDev",
  "kaufmanRange",
  "userScript",
];

export const INDICATOR_REGISTRY_UI = [
  {
    category: "Trend",
    keys: ["ma", "sma", "ema", "wma", "vwap", "hma", "dema", "tema", "ichimoku", "sar", "donchian", "keltner", "bb"],
  },
  {
    category: "Momentum",
    keys: ["rsi", "cci", "williams", "roc", "mom", "stochastic", "stochRsi", "macd", "ao", "tsi", "kaufmanRange"],
  },
  {
    category: "Volatility",
    keys: ["atr", "bb", "donchian", "keltner", "stdDev", "chaikinVol"],
  },
  {
    category: "Volume",
    keys: ["obv", "cmf", "mfi", "adLine", "volOsc"],
  },
];
